// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const TagCreateForm = registerClientReference(
    function() { throw new Error("Attempted to call TagCreateForm() from the server but TagCreateForm is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/admin/tags/_form.tsx",
    "TagCreateForm",
);
export const TagRow = registerClientReference(
    function() { throw new Error("Attempted to call TagRow() from the server but TagRow is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/admin/tags/_form.tsx",
    "TagRow",
);
